export const MAX_VELO_DELTA_MPH = 3;
export const MAX_SPIN_DELTA_RPM = 400;
export const MAX_BREAKS_DELTA_IN = 6;
export const MAX_BREAKS_DELTA_IN_TRAJEKT_36 = 8;
export const MAX_PLATE_DELTA_IN = 8;
